import type { FunctionComponent } from "react";
import styled from "styled-components";
import { URLS } from "@constants";
import { getTheme, Flow, IconButton, } from "@bracket/ui";
import type { CSSSpaceDeclaration, } from "@bracket/ui/types";


export declare type SocialBarProps = {
	button?: boolean;
	spacing?: CSSSpaceDeclaration;
};

export const SocialIconsBar: FunctionComponent<SocialBarProps> = ({
	button,
	...props
}) => {

	const onOpen = (platform: "x" | "discord" | "telegram") => {
		switch (platform) {
			case "x":
				return window.open(URLS.TWITTER, "_blank");
			case "discord":
				return window.open(URLS.DISCORD, "_blank");
			case "telegram":
				return window.open(URLS.TELEGRAM, "_blank");
		}
	};

	return (
		<SocialBarWrapper {...props}>
			<IconButton icon="X" iconColor="surface_light" iconSize="20px" onClick={() => onOpen("x")} pad="0rem" button={button} margin="0.5rem" />
			<IconButton icon="Discord" iconColor="surface_light" iconSize="20px" onClick={() => onOpen("discord")} pad="0rem" button={button} margin="0.5rem" />
			<IconButton icon="Telegram" iconColor="surface_light" iconSize="20px" onClick={() => onOpen("telegram")} pad="0rem" button={button} margin="0.5rem" />
		</SocialBarWrapper>
	);
};

const SocialBarWrapper = styled(Flow).attrs({ $flow: "stream", $flexible: true, })`
  height: 3em;
  align-items: center;
`;
